// 1. 下記文字を含めない: スラッシュ(/), バックスラッシュ(\), 改行(\n)
// 2. ダッシュ(-)で開始しない
// 3. 下記文字で終了しない: スペース( ), ドット(.)
export const pjNameValidationCheck = (str: string) => {
  const regexHead = /^-/;
  const regexEnd = /[ 　.]$/;
  const regexContent = /[\\/\r\n]/;

  return !(regexHead.test(str) || regexEnd.test(str) || regexContent.test(str));
};
